
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import FormHeader from "../common/FormHeader";
import axios from "axios";
import { toast } from "react-toastify";
import "./formTitle.css";
import "./themePlaceholder.css";

function SiteRegister() {
  const navigate = useNavigate();
  const sigCanvasRef = useRef(null);
  const [form, setForm] = useState({
    firstName: "",
    surname: "",
    jobTitle: "",
    department: "",
    date: "",
    timeIn: "",
    timeOut: "",
    siteLocation: "",
    signature: ""
  });

  // Handle input changes
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Signature pad handlers
  const clearSignature = () => {
    sigCanvasRef.current.clear();
    setForm(prev => ({
      ...prev,
      signature: ""
    }));
  };

  const saveSignature = () => {
    if (!sigCanvasRef.current.isEmpty()) {
      setForm(prev => ({
        ...prev,
        signature: sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      // Get userId from localStorage user
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user && user.id;
      if (!userId) {
        toast.error("User not found");
        return;
      }
      const payload = {
        userId,
        date: form.date,
        time_in: form.timeIn,
        time_out: form.timeOut,
        surname: form.surname,
        first_name: form.firstName,
        job_title_department: form.jobTitle,
        site_location: form.siteLocation,
        signature: form.signature
      };
      const token = localStorage.getItem("token");
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      await axios.post(`${baseUrl}/api/site-register`, payload, config);
      toast.success("Site register submitted successfully");
      navigate(`/site-register-list`);
    } catch (err) {
      toast.error("Failed to submit site register");
    }
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
      {/* <div className="container py-4 position-relative" */}
        {/* <button
          onClick={() => window.history.back()}
          className="btn fw-semibold position-absolute"
          style={{
            left: "-63px",
            color: "#8b1634",
            padding: "8px 20px",
            whiteSpace: "nowrap",
            zIndex: 10,
          }}
        >
          <i className="fa fa-arrow-left"></i> Back
        </button> */}
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            Site Register
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">

              {/* First Name */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">First Name</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-user" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={form.firstName}
                    onChange={handleChange}
                    required
                    placeholder="Enter First Name"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "40px"
                    }}
                    onFocus={(e) => e.target.style.borderColor = "#8b1634"}
                    onBlur={(e) => e.target.style.borderColor = "#eaf0fe"}
                  />
                </div>
              </div>

              {/* Surname */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Surname</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-user" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input
                    type="text"
                    className="form-control"
                    name="surname"
                    value={form.surname}
                    onChange={handleChange}
                    required
                    placeholder="Enter Surname"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "40px"
                    }}
                    onFocus={(e) => e.target.style.borderColor = "#8b1634"}
                    onBlur={(e) => e.target.style.borderColor = "#eaf0fe"}
                  />
                </div>
              </div>

              {/* Job Title & Department */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Job Title & Department</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-briefcase" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input
                    type="text"
                    className="form-control"
                    name="jobTitle"
                    value={form.jobTitle}
                    onChange={handleChange}
                    required
                    placeholder="Enter Job Title & Department"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "40px"
                    }}
                    onFocus={(e) => e.target.style.borderColor = "#8b1634"}
                    onBlur={(e) => e.target.style.borderColor = "#eaf0fe"}
                  />
                </div>
              </div>

              {/* Date */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  required
                  placeholder="Enter Date"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    paddingLeft: "10px"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#8b1634"}
                  onBlur={(e) => e.target.style.borderColor = "#eaf0fe"}
                />
              </div>

              {/* Time In */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Time In</label>
                <input
                  type="time"
                  className="form-control"
                  name="timeIn"
                  value={form.timeIn}
                  onChange={handleChange}
                  required
                  placeholder="Enter Time In"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    paddingLeft: "10px"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#8b1634"}
                  onBlur={(e) => e.target.style.borderColor = "#eaf0fe"}
                />
              </div>

              {/* Time Out */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Time Out</label>
                <input
                  type="time"
                  className="form-control"
                  name="timeOut"
                  value={form.timeOut}
                  onChange={handleChange}
                  required
                  placeholder="Enter Time Out"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    paddingLeft: "10px"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#8b1634"}
                  onBlur={(e) => e.target.style.borderColor = "#eaf0fe"}
                />
              </div>

              {/* Site Location */}
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Site Location</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-map-marker" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input
                    type="text"
                    className="form-control"
                    name="siteLocation"
                    value={form.siteLocation}
                    onChange={handleChange}
                    required
                    placeholder="Enter Site Location"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "40px"
                    }}
                    onFocus={(e) => e.target.style.borderColor = "#8b1634"}
                    onBlur={(e) => e.target.style.borderColor = "#eaf0fe"}
                  />
                </div>
              </div>

              {/* Signature */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Signature</label>
                <div style={{
                  width: '100%',
                  border: '2px solid #8b1634',
                  borderRadius: '18px',
                  background: '#e9cfd6',
                  padding: '0.5rem',
                  textAlign: 'left',
                  position: 'relative',
                  minHeight: '120px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="#8b1634"
                    backgroundColor="#e9cfd6"
                    clearOnResize={false}
                    velocityFilterWeight={0.7}
                    minWidth={1}
                    maxWidth={2.5}
                    dotSize={1.5}
                    throttle={16}
                    canvasProps={{
                      width: window.innerWidth > 600 ? 350 : 300,
                      height: 100,
                      style: {
                        width: '100%',
                        height: '100px',
                        border: 'none',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        display: 'block',
                        touchAction: 'none'
                      }
                    }}
                    onEnd={saveSignature}
                  />
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '4px'
                  }}>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm rounded-pill px-3"
                      style={{
                        background: 'transparent',
                        color: '#8b1634',
                        borderColor: '#8b1634'
                      }}
                      onClick={clearSignature}>
                      Clear
                    </button>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2"
                  style={{
                    backgroundColor: "#8b1634",
                    borderRadius: "30px",
                    boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
                  }}>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SiteRegister;
